import { render, staticRenderFns } from "./PayRangeVersionHistoryList.vue?vue&type=template&id=6bfc7bfc&scoped=true"
import script from "./PayRangeVersionHistoryList.vue?vue&type=script&setup=true&lang=js"
export * from "./PayRangeVersionHistoryList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PayRangeVersionHistoryList.vue?vue&type=style&index=0&id=6bfc7bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfc7bfc",
  null
  
)

export default component.exports